import React from "react"
import types from "prop-types"
import * as DateDifferenceAttributes from "./DateDifferenceAttributes"
import QuestionShowDescription from "./QuestionShowDescription"

const DateDifferenceInputConfig = ({ sectionIndex, questionIndex }) => (
  <>
    <QuestionShowDescription
      sectionIndex={sectionIndex}
      questionIndex={questionIndex}
    />
    <div className="mb-4">
      <DateDifferenceAttributes.Dates
        sectionIndex={sectionIndex}
        questionIndex={questionIndex}
      />
    </div>
    <DateDifferenceAttributes.UnitOfMeasure
      sectionIndex={sectionIndex}
      questionIndex={questionIndex}
    />
  </>
)

DateDifferenceInputConfig.propTypes = {
  sectionIndex: types.number.isRequired,
  questionIndex: types.number.isRequired,
}

export default DateDifferenceInputConfig
